<template>
	<div class="flex space-x-4">
		<ui-select-group
			class="flex-grow"
			v-model="localStatus"
			:form="{}"
			field="status"
			type="select"
			label="Status"
			:no-label="true"
			:options="thread.status_options"
			:required="true"
		></ui-select-group>

		<ui-button v-bind:disabled="buttonDisabled" v-on:click="postUpdate()">
			{{ __("Save") }}
		</ui-button>
	</div>
</template>

<script>
export default {
	props: {
		thread: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			buttonLock: false,
			localStatus: this.thread.status,
		};
	},
	computed: {
		// Auswaehlbare Status kommen serverseitig ueber thread.status_options (Detail-Request):
		// die Regel "nach Kontraktschluss kein Reopen auf UNDER_NEGOTIATION" liegt im Backend.
		// Kein Fallback — wir vertrauen darauf, dass der Detail-Thread status_options traegt.
		buttonDisabled() {
			return this.buttonLock || this.thread.status == this.localStatus;
		},
	},
	methods: {
		async postUpdate() {
			this.buttonLock = true;

			try {
				let req = await axios.post(
					this.$route("api.thread_event.store_status", {
						threadId: this.thread.id,
					}),
					{
						data: {
							status: this.localStatus,
						},
					}
				);
				let updatedThread = req.data.data;
				this.$bus.$emit("thread-update", updatedThread);
				this.$emit("done");
			} catch (e) {
				// Validierungsfehler (422) inline an der Status-Auswahl zeigen (form:invalid →
				// ui-select-group, field "status"). Auswahl auf den tatsaechlichen Status zuruecksetzen.
				this.$bus.$emit("form:invalid", e.response?.data?.errors);
				this.localStatus = this.thread.status;
			} finally {
				this.buttonLock = false;
			}
		},
	},
};
</script>
